module.exports = __webpack_public_path__ + "img/ca.4cf48425.svg";